import { useState, type FormEvent } from 'react'
import { Link } from '@tanstack/react-router'
import { useCreateList, useSavedLists } from '../../api/queries'
import { dateShort } from '../../api/format'
import { useListMotion } from '../../theme/motion'
import { Shell } from '../../app/Shell'
import { Alert, Button, Empty, Skeletons } from '../../ui/kit'

export function ListsPage() {
  const lists = useSavedLists()
  const create = useCreateList()
  const [name, setName] = useState('')
  const [gridRef] = useListMotion<HTMLDivElement>()
  const submit = (event: FormEvent) => {
    event.preventDefault()
    const trimmed = name.trim()
    if (!trimmed) return
    create.mutate({ name: trimmed }, { onSuccess: () => setName('') })
  }
  return (
    <Shell
      head={
        <div className="toolbar">
          <div className="tt"><h1 className="t-page">Lists</h1><span className="pill is-muted">{lists.data ? `${lists.data.length} lists` : '…'}</span></div>
          <form className="ta" onSubmit={submit}>
            <label className="tool-field"><span>New list</span><input value={name} onChange={e => setName(e.target.value)} placeholder="Name" aria-label="New list name" style={undefined} /></label>
            <Button type="submit" kind="primary" disabled={!name.trim() || create.isPending}>Create</Button>
          </form>
        </div>
      }
      status={<span>Lists are your memory: a lot saved here keeps its place across sessions and devices.</span>}
    >
      {create.isError ? <Alert title="The list was not created">{create.error.message}</Alert> : null}
      {lists.isError ? <Alert title="Lists are unavailable">{lists.error.message}</Alert> : lists.isPending ? <div className="list-grid"><Skeletons count={4} /></div> : lists.data.length === 0 ? (
        <Empty title="No lists yet">Create one above, or use Save on any card.</Empty>
      ) : (
        <div className="list-grid" ref={gridRef}>
          {lists.data.map(list => (
            <Link key={list.id} to="/" search={{ listId: list.id }} className="list-card">
              <span className="n">{list.name}</span>
              <span className="d">{list.description || 'No description'}</span>
              <span className="c">{list.propertyCount}</span>
              <span className="d">{list.propertyCount === 1 ? 'property' : 'properties'}</span>
              <span className="m"><span>{list.legalPackCount} packs</span><span>Updated {dateShort(list.updatedAt)}</span></span>
            </Link>
          ))}
        </div>
      )}
    </Shell>
  )
}
